import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

import Experience from './Experience'

export default class Camera {
  constructor() {
    //setup
    this.experience = new Experience()
    this.sizes = this.experience.sizes
    this.scene = this.experience.scene
    this.canvas = this.experience.canvas

    //Methods
    this.setCamera()
    this.setControls()
  }

  setCamera() {
    this.instance = new THREE.PerspectiveCamera(45, this.sizes.width / this.sizes.height, 0.1, 100)
    this.instance.position.set(0, 2, 16)

    this.instance.lookAt({ x: 0, y: 0, z: 0 })
    this.scene.add(this.instance)
  }
  setControls() {
    this.controls = new OrbitControls(this.instance, this.canvas)
    this.controls.enableDamping = true
    this.controls.enablePan = false
    this.controls.maxPolarAngle = Math.PI * 0.5
    this.controls.minAzimuthAngle = -Math.PI * 0.25
    this.controls.maxAzimuthAngle = Math.PI * 0.25
    this.controls.minDistance = 3.5
    this.controls.maxDistance = 20
  }
  resize() {
    this.instance.aspect = this.sizes.width / this.sizes.height
    this.instance.updateProjectionMatrix()
  }

  update() {
    this.controls.update()

    if (window.matchMedia('(min-width: 960px)').matches) {
    } else if (window.matchMedia('(min-width: 720px)').matches) {
    } else if (window.matchMedia('(min-width: 480px)').matches) {
      this.controls.minDistance = 3.5
      this.controls.maxDistance = 25
    } else {
      this.controls.minDistance = 3.5
      this.controls.maxDistance = 25
    }
  }
}
